export function AccountIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_472_8438)">
        <path
          d="M3.54418 12.9596C3.94973 12.0041 4.89659 11.334 5.99998 11.334H9.99998C11.1034 11.334 12.0502 12.0041 12.4558 12.9596M10.6666 6.33398C10.6666 7.80674 9.47274 9.00065 7.99998 9.00065C6.52722 9.00065 5.33331 7.80674 5.33331 6.33398C5.33331 4.86123 6.52722 3.66732 7.99998 3.66732C9.47274 3.66732 10.6666 4.86123 10.6666 6.33398ZM14.6666 8.00065C14.6666 11.6826 11.6819 14.6673 7.99998 14.6673C4.31808 14.6673 1.33331 11.6826 1.33331 8.00065C1.33331 4.31875 4.31808 1.33398 7.99998 1.33398C11.6819 1.33398 14.6666 4.31875 14.6666 8.00065Z"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_472_8438">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
